module.exports = __webpack_public_path__ + "img/beijinglogo.5d15bc25.jpeg";